import * as React from "react";

import { LoaderCircle } from "lucide-react";

import { cn } from "../../lib/cn";

import {
  Button as PrimitiveButton,
  buttonVariants,
} from "../../primitive/button";

export type ButtonProps = React.ComponentProps<typeof PrimitiveButton> & {
  loading?: boolean;
};

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { loading: loading = false, children, className, disabled, ...props },
    ref,
  ) => {
    return (
      <PrimitiveButton
        ref={ref}
        className={cn(
          "relative overflow-hidden not-disabled:cursor-pointer",
          loading && "cursor-progress",
          className,
        )}
        disabled={disabled || loading}
        {...props}
      >
        <span
          aria-hidden={!loading}
          className={cn(
            "absolute inset-0 flex items-center justify-center transition-transform duration-200",
            loading ? "translate-y-0" : "translate-y-[150%]",
          )}
        >
          <LoaderCircle className="size-4 animate-spin" />
        </span>

        <span
          className={cn(
            "flex items-center justify-center gap-2 transition-transform duration-200",
            loading && "-translate-y-[150%]",
          )}
        >
          {children}
        </span>
      </PrimitiveButton>
    );
  },
);

Button.displayName = "Button";

export { buttonVariants };
